<div class="calendar-page">
  <div class="header-card">
    <div>
      <h1>Calendário</h1>
      <p>Visão mensal das tarefas cadastradas no Planejamento das perícias.</p>
    </div>
    <button type="button" class="btn-light" (click)="carregar()">Atualizar</button>
  </div>

  <div class="filters">
    <label>
      <span>Ano</span>
      <input type="number" [(ngModel)]="ano">
    </label>

    <label>
      <span>Mês</span>
      <select [(ngModel)]="mes">
        <option *ngFor="let m of meses" [value]="m.valor">{{ m.nome }}</option>
      </select>
    </label>

    <label class="pericia-filter">
      <span>Perícia</span>
      <select [(ngModel)]="periciaFiltro">
        <option [ngValue]="0">Todas</option>
        <option *ngFor="let p of pericias()" [ngValue]="p.id">{{ p.codigo }} - {{ p.titulo }}</option>
      </select>
    </label>
  </div>

  <div class="calendar-card">
    <div class="week-head" *ngFor="let d of semana">{{ d }}</div>

    <div class="day" *ngFor="let dia of diasCalendario()" [class.empty]="dia.foraMes">
      <div class="day-number" *ngIf="!dia.foraMes">{{ dia.dia }}</div>

      <div class="task" *ngFor="let t of dia.tarefas" [ngClass]="classeStatus(t.status)">
        <strong>{{ t.etapa }}</strong>
        <span>{{ t.tarefa }}</span>
        <small>{{ t.responsavel || 'Sem responsável' }}</small>
      </div>
    </div>
  </div>
</div>
